<template>
    <div class="setting-ctn">
        <hc-menu collapse router :default-active="$route.path">
            <hc-menu-item
                v-for="tab in tabs"
                :key="tab.name"
                :index="`${baseRoute}/${tab.path}`"
                :class="{'is-active': isRouteActive(tab)}"
            >
                <svg-icon v-if="!isRouteActive(tab)" :name="tab.meta.iconName" />
                <svg-icon v-else :name="`${tab.meta.iconName}-active`" />

                <p>{{ tab.meta.title }}</p>
            </hc-menu-item>
        </hc-menu>
        <div class="setting-ctn__content">
            <Breadcrumb v-if="!($route.meta && $route.meta.withoutBreadcrumb)" />
            <common-tips v-if="$route.meta && $route.meta.tips" :content="$route.meta.tips" />
            <div :class="viewContentCls">
                <router-view class="setting-ctn__content__ctn_body" />
            </div>
        </div>
    </div>
</template>
<script>
import NavMinxin from '../app-resource/mixins/left-nav'

export default {
    name: 'SettingEntry',
    mixins: [NavMinxin],
    data() {
        return {
            routeName: 'setting',
        }
    },
    computed: {
        viewContentCls() {
            const cls = ['setting-ctn__content__ctn']
            if (this.$route.meta && this.$route.meta.fullscreen) {
                cls.push('setting-ctn__content__ctn--fullscreen')
            }
            return cls
        },
    },
    
}
</script>
<style lang="less" scoped>
.setting-ctn {
    height: 100%;
    display: flex;
    &__content {
        flex: 1;
        display: flex;
        overflow-x: auto;
        flex-direction: column;
        background: rgb(245, 247, 251);
        &__ctn {
            flex: 1;
            margin: 16px;
            overflow-y: auto;
            &::-webkit-scrollbar{
                width: 0px;
            }
            &_body{
                height: 100%;
                width: 100%;
            }
            &--fullscreen{
                margin: 0;
            }
        }
    }
}
</style>
